import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const ShimmerUI = () => {
  const [theme, setTheme] = useState(document.documentElement.getAttribute('data-bs-theme') || 'light');

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const current = document.documentElement.getAttribute('data-bs-theme') || 'light';
      setTheme(current);
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-bs-theme']
    });

    return () => observer.disconnect();
  }, []);

  const shimmerClass = theme === 'dark' ? 'shimmer shimmer-dark' : 'shimmer shimmer-light';

  return (
    <div className="container p-3">
      <div className={`shimmer ${theme === 'dark' ? 'shimmer-dark' : 'shimmer-light'} pulse rounded`} style={{ height: '20px', width: '120px' }}></div>
      <div className="d-flex justify-content-between mb-4">
        <div className="d-flex flex-column align-items-start">
          <div className="mb-2">
            <div className={`bg-secondary ${shimmerClass} rounded mb-2`} style={{ height: "10px", width: "150px" }}></div>
            <div className={`bg-secondary ${shimmerClass} rounded`} style={{ height: "10px", width: "200px" }}></div>
          </div>
          <div className={`rounded-circle ${shimmerClass} bg-secondary`} style={{ width: "50px", height: "50px" }}></div>
        </div>
        <div className="d-flex gap-3 align-items-start">
          <div className={`bg-secondary ${shimmerClass} rounded-pill`} style={{ height: "30px", width: "120px" }}></div>
          <div className={`bg-secondary ${shimmerClass} rounded-pill`} style={{ height: "30px", width: "150px" }}></div>
        </div>
      </div>
      <div className="d-flex gap-2 mb-4">
        {[...Array(6)].map((_, index) => (
          <div key={index} className={`bg-secondary ${shimmerClass} rounded`} style={{ height: "40px", width: "120px" }}></div>
        ))}
      </div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className={`bg-secondary ${shimmerClass} rounded`} style={{ height: "30px", width: "150px" }}></div>
        <div className={`bg-secondary ${shimmerClass} rounded`} style={{ height: "30px", width: "200px" }}></div>
      </div>
      <div className="mt-4">
        <div className="d-flex gap-3 mb-3">
          {[50, 120, 80, 60, 100].map((w, i) => (
            <div key={i} className={`bg-secondary ${shimmerClass} rounded`} style={{ height: "20px", width: `${w}px` }}></div>
          ))}
        </div>
        {[...Array(5)].map((_, rowIndex) => (
          <div className="d-flex gap-3 mb-2" key={rowIndex}>
            {[50, 120, 80, 60, 100].map((w, i) => (
              <div key={i} className={`bg-secondary ${shimmerClass} rounded`} style={{ height: "20px", width: `${w}px` }}></div>
            ))}
          </div>
        ))}
      </div>
      <style>
        {`
          .shimmer {
            animation: shimmer 1.5s infinite linear;
            background-size: 200% 100%;
          }

          .shimmer-light {
            background: linear-gradient(
              to right,
              #e0e0e0 0%,
              #f0f0f0 50%,
              #e0e0e0 100%
            );
          }

          .shimmer-dark {
            background: linear-gradient(
              to right,
              #2e2e2e 0%,
              #444444 50%,
              #2e2e2e 100%
            );
          }

          @keyframes shimmer {
            0% {
              background-position: 200% 0;
            }
            100% {
              background-position: -200% 0;
            }
          }
        `}
      </style>
    </div>
  );
};

export default ShimmerUI;